<script setup lang="ts">
import { useUserStore } from '../../../../stores';
import { UserRole } from '../../../../types/user';
import StudentQuiz from './StudentQuiz.vue';
import TeacherQuiz from './TeacherQuiz.vue';

const user = useUserStore()

</script>

<template>
    <TeacherQuiz v-if="user.userRole === UserRole.teacher" />
    <StudentQuiz v-if="user.userRole === UserRole.student" />
</template>